__webpack_require__.p = "https://qa-connected-products-mfe.digital.vpsvc.com/";